import React, { useEffect, useState } from "react";
import styles from "./profileComp.module.scss";
import { useProfile } from "../../../../context/ProfileContext";
import Icon from "../../../../components/Icon";
import { RawWorkExperience } from "../../types";
import Button from "../../../../components/Button";
import { userProfile } from "../../types";
const WorkExperience = () => {
  const {
    profileInfo,
    handleFocus,
    current,
    setProfileInfo,
    handleSubmit,
    handleDiscardData,
    handleDiscard,
  } = useProfile();

  const [profiles, setProfiles] = useState<userProfile | null>(null);
  const [focus, setFocus] = useState<number | null>(null);

  useEffect(() => {
    setProfiles(profileInfo);
  }, []);

  const handleWork = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const { name, value } = e.target;
    setProfileInfo((prev: any) => ({
      ...prev,
      workExperiences: [
        ...prev.workExperiences?.map((item: RawWorkExperience, i: number) => {
          if (i === index) {
            return {
              ...item,
              [name]: name === "startDate" || name === "endDate" ? yyyyMmDd(value) : value,
            };
          }
          return item;
        }),
      ],
    }));
  };

  const AddWork = () => {
    const data = {
      organization: "",
      jobRole: "",
      startDate: "",
      endDate: "",
    };

    setProfileInfo((prev: any) => ({
      ...prev,
      workExperiences: [...prev.workExperiences, data],
    }));
  };

  const ddMmYyyy = (date: string) => {
    const [d, m, year] = date.split("-");
    return `${year}-${m}-${d}`;
  };

  const yyyyMmDd = (date: string) => {
    const [year, m, d] = date.split("-");
    return `${d}-${m}-${year}`;
  };

  console.log(current);
  return (
    <div
      className={`${current?.section === "work" ? `${styles.editing} ` : null} ${
        styles.InfoContainer
      }`}
    >
      <div className={styles.Header}>
        <h3>Work Experience</h3>
        <div className={styles.actions}>
          {current?.section === "work" && (
            <div className={styles.headerStatus}>
              <Icon name="edit" width={15} height={15} className={styles.edits} />
              <p>editing</p>
            </div>
          )}
        </div>
      </div>

      <div>
        {profileInfo?.workExperiences?.map((item, index) => (
          <div key={index} className={`${styles.boxInp}`}>
            {Object.keys(item).map((key) => {
              return (
                <div key={key} className={styles.contBoxes}>
                  <label htmlFor={key} className={styles.labels}>
                    {key === "organization"
                      ? "Orgarnisation"
                      : key === "jobRole"
                      ? "Job Role"
                      : key === "startDate"
                      ? "Start Date"
                      : key === "endDate"
                      ? "End Date"
                      : key}
                  </label>
                  <div className={`${styles.inputContainer}`}>
                    <input
                      type={key === "endDate" || key === "startDate" ? "date" : "text"}
                      name={key}
                      value={
                        key === "endDate" || key === "startDate"
                          ? ddMmYyyy(item[key as keyof RawWorkExperience])
                          : item[key as keyof RawWorkExperience]
                      }
                      className={`${styles.basicInputs}`}
                      placeholder={
                        key === "organization"
                          ? "Orgarnisation"
                          : key === "jobRole"
                          ? "Job Role"
                          : key === "startDate"
                          ? "Start Date"
                          : key === "endDate"
                          ? "End Date"
                          : key
                      }
                      onChange={(e) => handleWork(e, index)}
                      onFocus={() => {
                        handleFocus(key, "work", index);
                        handleDiscardData("workExperiences");
                        setFocus(index);
                      }}
                    />

                    <div>
                      {key !== "endDate" && key !== "startDate" && (
                        <Icon name="edit" width={20} height={20} className={styles.edits} />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            {focus === index && (
              <div className={styles.saves}>
                <button
                  className={styles.save}
                  onClick={(e: any) => handleSubmit(e, "workExperiences")}
                >
                  Save
                </button>
                <button className={styles.discard} onClick={() => handleDiscard("workExperiences")}>
                  Discard
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
      <Button variant="primary" onClick={AddWork} className={styles.adds}>
        <Icon name="add" width={15} height={15} color="white" className={styles.edits} />
        <span>Add</span>
      </Button>
    </div>
  );
};

export default WorkExperience;
